import type {
  RestoreAccount,
  InventoryResource,
  Snapshot,
} from '@repo/api-gw-sdk';
import { Provider } from '@repo/api-gw-sdk';

import { KeyspacesConfiguration } from './steps/keyspacesConfiguration';
import { SelectTargetAccountStep } from './steps/selectTargetAccount';

import type { Encryption } from '../encryption/encryptionComponent';
import type { Step } from '../wizard/Step';
import { Wizard } from '../wizard/Wizard';

export interface RestoreKeyspacesState {
  resourceId: string;
  snapshot: Snapshot;
  keyspaceName?: string;
  tableName?: string;
  supportedCloudProviders: Provider[];
  restoreAccount?: RestoreAccount;
  regionName?: string;
  tags: Record<string, string>;
  initialTags: Record<string, string>;
  keepOriginalTags: boolean;
  encryption?: Encryption;
  initialRegionName: string;
}

const restoreKeyspacesFlow: Step<RestoreKeyspacesState> = {
  id: 'select_target_account_step',
  Component: SelectTargetAccountStep,
  next: [
    {
      id: 'keyspaces_configuration',
      Component: KeyspacesConfiguration,
    },
  ],
};

export const RestoreKeyspacesWizard = ({
  resource,
  snapshot,
  onClose,
  onBack,
}: {
  resource: InventoryResource;
  snapshot: Snapshot;
  onClose: () => void;
  onBack: () => void;
}) => {
  const keyspaceName =
    resource.resourceProperties?.awsKeyspacesTable?.keyspaceName || '';
  const tableName =
    resource.resourceProperties?.awsKeyspacesTable?.tableName || '';

  return (
    <Wizard<RestoreKeyspacesState>
      onAbort={(origin) => (origin === 'back' ? onBack() : onClose())}
      onFinish={async () => true}
      flow={[restoreKeyspacesFlow]}
      initialState={{
        initialRegionName: resource.region || 'us-east-1',
        snapshot,
        resourceId: snapshot.resourceId,
        supportedCloudProviders: [Provider.Aws],
        keepOriginalTags: true,
        initialTags: snapshot.resource?.tags || {},
        tags: snapshot.resource?.tags || {},
        keyspaceName,
        tableName,
      }}
      title='Restore Keyspaces Table'
      stepperLabels={['Restore Account', 'Configuration']}
    />
  );
};
